var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgLogoDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 447,
    height: 462,
    viewBox: "0 0 447 462",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M351.765 359.676L208.422 461.129L208.195 92.5061C208.164 41.6866 249.346 0.472656 300.158 0.472656H446.002V124.162H397.747C372.352 124.162 351.765 144.752 351.765 170.151V359.676Z",
    fill: "white",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M184.647 92.5416C184.647 143.39 143.433 184.611 92.592 184.611C41.7512 184.611 0.536621 143.39 0.536621 92.5416C0.536621 41.6933 41.7512 0.472656 92.592 0.472656C143.433 0.472656 184.647 41.6933 184.647 92.5416Z",
    fill: "white",
    fillOpacity: 0.15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M351.66 359.737L281.064 409.712V115.869C281.064 84.1208 306.797 58.3836 338.541 58.3836L445.934 58.3828V124.209H397.642C372.247 124.209 351.66 144.799 351.66 170.197V359.737Z",
    fill: "white",
    fillOpacity: 0.05
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLogoDesktop);
export default __webpack_public_path__ + "static/media/bg-logo-desktop.2a5e6bce95979934f7701755d30c0ba2.svg";
export { ForwardRef as ReactComponent };